import { useState, useEffect } from 'react';
import { Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { M } from '../shared/constants';

export function ImagePreviewModal({ src, onClose }) {
  useEffect(() => {
    if (!src) return;
    const onKey = e => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [src, onClose]);
  if (!src) return null;
  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, zIndex: 2000, background: 'rgba(0,0,0,0.88)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16, cursor: 'zoom-out' }}>
      <button onClick={onClose} aria-label="Close" style={{ position: 'absolute', top: 16, right: 16, width: 38, height: 38, borderRadius: '50%', border: 'none', background: 'rgba(255,255,255,0.15)', color: '#fff', fontSize: 16, cursor: 'pointer' }}>
        <CloseOutlined />
      </button>
      <img src={src} alt="" onClick={e => e.stopPropagation()} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', borderRadius: 6, cursor: 'default' }} />
    </div>
  );
}

export function NewsDetailModal({ item, onClose }) {
  const [preview, setPreview] = useState(null);
  return (
    <>
      <Modal open={!!item} onCancel={onClose} footer={null} centered width={640}
        bodyStyle={{ padding: 0, maxHeight: '85vh', overflowY: 'auto' }}
        closeIcon={<span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 30, height: 30, borderRadius: '50%', background: 'rgba(0,0,0,0.55)', color: '#fff' }}><CloseOutlined /></span>}>
        {item && (
          <div>
            {item.image_url && (
              <div style={{ background: '#111827', cursor: 'zoom-in' }} onClick={() => setPreview(item.image_url)}>
                <img src={item.image_url} alt={item.title} style={{ display: 'block', width: '100%', maxHeight: '55vh', objectFit: 'contain', margin: '0 auto' }} />
              </div>
            )}
            <div style={{ padding: '16px 20px 20px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8, flexWrap: 'wrap' }}>
                {item.category_name && <span style={{ fontSize: 10, fontWeight: 700, color: item.category_color || M, background: `${item.category_color || M}15`, borderRadius: 4, padding: '2px 8px' }}>{item.category_name}</span>}
                {item.post_date && <span style={{ fontSize: 11, color: '#9ca3af' }}>{new Date(item.post_date).toLocaleDateString('hi-IN', { day: 'numeric', month: 'long', year: 'numeric' })}</span>}
              </div>
              <div style={{ fontSize: 17, fontWeight: 800, color: '#111827', lineHeight: 1.4, marginBottom: 10 }}>{item.title}</div>
              {item.content && <div style={{ fontSize: 14, color: '#374151', lineHeight: 1.8, whiteSpace: 'pre-wrap' }}>{item.content}</div>}
            </div>
          </div>
        )}
      </Modal>
      <ImagePreviewModal src={preview} onClose={() => setPreview(null)} />
    </>
  );
}
